import React from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { Popconfirm, Input, Button, Pagination, Row, Col } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { SERVER_IP } from 'assets/Config';
import TableComponent from 'components/table-component';
import { deleteApi } from 'redux/sagas/deleteApiSaga';
import AddDietPlanTemplate from 'pages/diet-plan-template/add-diet-plan-template';
import { useI18n } from 'hooks/useI18n';

const DietPlanTemplateListPresentational = ({
	filteredData,
	column,
	tableLoading,
	rowSelection,
	selectedRowKeys,
	handleAddDietPlanTemplate,
	currentPage,
	pageSize,
	initialPageSizeOptions,
	initialPageSize,
	handleTableChange,
	setSearchKey,
	getStartingValue,
	getEndingValue,
	dietPlanTemplateAddModal,
	setDietPlanTemplateAddModal,
	refreshList,
	editDietPlanTemplate,
	handleClose,
}) => {
	const dispatch = useDispatch();
	const { t } = useI18n();
	return (
		<>
			<Row>
				<Col span={24} style={{ padding: 0 }}>
					<TableComponent
						loading={tableLoading}
						className="custom-table"
						style={{ width: '100%' }}
						columns={column}
						bordered
						rowKey={(record) => record.id}
						dataSource={filteredData}
						rowSelection={rowSelection}
						title={() => (
							<Row style={{ justifyContent: 'space-between' }}>
								<Col span={8}>
									<Row gutter={[10, 10]}>
										<Col xl={24}>
											<Row gutter={[10, 10]} align="middle">
												<Col>
													<Input
														placeholder="Search"
														suffix={<AiOutlineSearch />}
														style={{ height: '30px' }}
														onChange={({ target: { value } }) => setSearchKey(value)}
													/>
												</Col>
												{selectedRowKeys?.length === 1 ? (
													<Col>
														<Popconfirm
															title={`Are you sure want to delete this Diet Template?`}
															okText="Delete"
															cancelText="No"
															onConfirm={() => {
																let url = `${SERVER_IP}api/dietPlanTemplate/${selectedRowKeys?.[0]}`;
																dispatch(deleteApi('DELETE_PT', url));
															}}>
															<div style={{ textDecoration: 'underline', color: 'red', cursor: 'pointer' }}>Delete</div>
														</Popconfirm>
													</Col>
												) : null}
											</Row>
										</Col>
									</Row>
								</Col>
								<Col>
									<Button
										type="primary"
										icon={<ReloadOutlined />}
										loading={tableLoading}
										onClick={() => refreshList?.()}
										style={{ marginRight: 10 }}
									/>
									<Button
										// icon={<PlusOutlined />}
										type="primary"
										// style={{ height: '30px', width: '100%' }}
										onClick={handleAddDietPlanTemplate}>
										{t('diet_plan.create_diet_template')}
									</Button>
								</Col>
							</Row>
						)}
						pagination={{
							current: currentPage,
							pageSize: pageSize,
							position: ['none', 'none'],
						}}
						footer={() => (
							<Row justify="space-between">
								<Col span={12}>
									{!!filteredData?.length && `Showing ${getStartingValue()} - ${getEndingValue()} of ${filteredData?.length} Data`}
								</Col>
								<Col span={12}>
									<div style={{ textAlign: 'right' }}>
										<Pagination
											pageSizeOptions={initialPageSizeOptions}
											defaultPageSize={initialPageSize}
											showSizeChanger={true}
											total={filteredData?.length}
											onChange={handleTableChange}
											responsive
										/>
									</div>
								</Col>
							</Row>
						)}
					/>
				</Col>
			</Row>
			{ dietPlanTemplateAddModal && <AddDietPlanTemplate {...{ dietPlanTemplateAddModal, setDietPlanTemplateAddModal, refreshList, editDietPlanTemplate, handleClose }} /> }
		</>
	);
};

export default DietPlanTemplateListPresentational;
